export default "__VITE_ASSET__BvOem2aS__"